import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="copy-a"
            d="M11.4,0 C11.6348571,0 11.8602857,0.098875 12.0222857,0.273 L14.7651429,3.2725 C14.916,3.43525 15,3.651375 15,3.875375 L15,13.125 C15,13.608 14.616,14 14.1428571,14 L3.85714286,14 C3.384,14 3,13.608 3,13.125 L3,0.875 C3,0.392 3.384,0 3.85714286,0 L11.4,0 Z M14,4 L11.4,4 C11.1792,4 11,3.8208 11,3.6 L11,1 L4,1 L4,13 L14,13 L14,4 L14,4 Z"/>
    </defs>
    <g>
      <use xlinkHref="#copy-a"/>
      <path d="M3,1 L2,1 C1.44771525,1 1,1.44771525 1,2 L1,15 C1,15.5522847 1.44771525,16 2,16 L12,16 C12.5522847,16 13,15.5522847 13,15 L13,14 L12,14 L12,15 L2,15 L2,2 L3,2 L3,1 Z"/>
    </g>
  </svg>
);
